import React from 'react';

const VerifiedProfilesBanner = () => {
  return (
    <section className="w-full py-8 sm:py-10 md:py-12 bg-white">
      <div className="w-full max-w-[1360px] mx-auto px-4 sm:px-6">
        <div
          className="bg-cover bg-center rounded-3xl p-8 sm:p-10 md:p-12 text-center overflow-hidden"
          style={{
            backgroundImage: "url('/images/couple_pose_2.webp')"
          }}
        >
          <div className="max-w-3xl ml-auto text-left">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-[36px] font-semibold text-white capitalize mb-3 sm:mb-4">
              Trusted by Appuppa Gounder Families
            </h2>
            <p className="text-base sm:text-lg text-white/70">
              Designed specifically to keep parents happy while giving you full control over how you find and interact with potential matches.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VerifiedProfilesBanner;